var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',{ref:"baseTable",attrs:{"service":_vm.$options.contractService,"fetch-func":"all","fetchParams":{
    exclude_archived: 1,
    includes: 'contractor',
    order_by: undefined,
    sort_by: undefined,
  },"columns":_vm.columns,"default-sort-field":"contractor.name","default-sort-direction":"asc","checkable":"","checked":_vm.contractsChecked,"custom-is-checked":function (a, b) { return a.id == b.id; },"is-row-checkable":function () { return _vm.canManageContracts; },"ui-pagination":""},on:{"update:checked":function($event){_vm.contractsChecked=$event},"check":_vm.onTableCheck,"check-all":_vm.onTableCheckAll},scopedSlots:_vm._u([{key:"rowContractor",fn:function(ref){
  var row = ref.row;
return [_vm._v("\n    "+_vm._s(row.contractor ? row.contractor.name : "")+"\n  ")]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e934c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Organization/persons/userContracts.vue
// module id = null
// module chunks = 